import { useFairePayEnrolmentInfo } from "@faire/retailer-visitor-shared/hooks/fairePay/useFairePayEnrolmentInfo";
import { intlDateWithTimezone } from "@faire/web--source/common/localization/date-fns/intlDate";
import { useQuery as useTotalReward } from "@faire/web-api--source/api/faire-pay/total-reward/get-hooks";
import { useQuery as useFairePayInfoQuery } from "@faire/web-api--source/api/payments/faire-pay/info/get-hooks";
import { IFairePay } from "@faire/web-api--source/indigofair/data/IFairePay";
import { IFairePayEnrollmentInfo } from "@faire/web-api--source/indigofair/data/IFairePayEnrollmentInfo";
import { useCallback } from "react";
export var useFairePayInfo = function(preventAutoRun) {
    var _useFairePayEnrolmentInfo = useFairePayEnrolmentInfo(), enrolmentInfo = _useFairePayEnrolmentInfo.enrolmentInfo, isEnrolmentInfoPending = _useFairePayEnrolmentInfo.isPending;
    var enabled = !preventAutoRun && (enrolmentInfo === null || enrolmentInfo === void 0 ? void 0 : enrolmentInfo.status) === IFairePayEnrollmentInfo.Status.ENROLLED;
    var _useFairePayInfoQuery = useFairePayInfoQuery({
        enabled: enabled
    }), fairePayInfo = _useFairePayInfoQuery.data, isFairePayInfoPending = _useFairePayInfoQuery.isPending, refetchFairePayInfo = _useFairePayInfoQuery.refetch;
    var _useTotalReward = useTotalReward({
        enabled: enabled
    }), totalRewardInfo = _useTotalReward.data, isTotalRewardPending = _useTotalReward.isPending, refetchTotalReward = _useTotalReward.refetch;
    var _fairePayInfo_faire_pay;
    var _ref = (_fairePayInfo_faire_pay = fairePayInfo === null || fairePayInfo === void 0 ? void 0 : fairePayInfo.faire_pay) !== null && _fairePayInfo_faire_pay !== void 0 ? _fairePayInfo_faire_pay : {}, payment_preference = _ref.payment_preference, next_payment_due_at = _ref.next_payment_due_at, live_current_balance = _ref.live_current_balance, live_statement_balance = _ref.live_statement_balance, available_balance = _ref.available_balance, min_required_payment_left = _ref.min_required_payment_left, reward_bps = _ref.reward_bps, state = _ref.state, time_zone = _ref.time_zone, enrolment_state = _ref.enrolment_state, current_period_end_at = _ref.current_period_end_at, banner = _ref.banner, balance_limit = _ref.balance_limit;
    var nextPaymentDueDateWithFormatting = function(format) {
        if (!next_payment_due_at || !time_zone) {
            return undefined;
        }
        return intlDateWithTimezone(next_payment_due_at, format, time_zone);
    };
    var currentPeriodEndDateWithFormatting = function() {
        if (!current_period_end_at || !time_zone) {
            return undefined;
        }
        return intlDateWithTimezone(current_period_end_at, "MMMM d", time_zone);
    };
    var refetch = useCallback(function() {
        refetchFairePayInfo();
        refetchTotalReward();
    }, [
        refetchFairePayInfo,
        refetchTotalReward
    ]);
    return {
        payment_preference: payment_preference,
        live_current_balance: live_current_balance,
        available_balance: available_balance,
        min_required_payment_left: min_required_payment_left,
        live_statement_balance: live_statement_balance,
        enrolment_state: enrolment_state,
        banner: banner,
        rewardPercentage: reward_bps ? reward_bps / 100 : undefined,
        totalSavingsToDate: totalRewardInfo === null || totalRewardInfo === void 0 ? void 0 : totalRewardInfo.total_reward_amount,
        refetch: refetch,
        isPending: enabled && (isFairePayInfoPending || isTotalRewardPending) || isEnrolmentInfoPending,
        state: state,
        nextPaymentDueDateWithFormatting: nextPaymentDueDateWithFormatting,
        currentPeriodEndDateWithFormatting: currentPeriodEndDateWithFormatting,
        showPreCheckoutUI: (enrolmentInfo === null || enrolmentInfo === void 0 ? void 0 : enrolmentInfo.status) !== IFairePayEnrollmentInfo.Status.ENROLLED || enrolment_state === IFairePay.EnrolmentState.PRE_ENROLLED,
        isFullyEnrolled: enrolment_state === IFairePay.EnrolmentState.FULLY_ENROLLED,
        isPreEnrolled: enrolment_state === IFairePay.EnrolmentState.PRE_ENROLLED || enrolment_state === IFairePay.EnrolmentState.PRE_ENROLLED_CHECKED_OUT,
        isPreEnrolledCheckedOut: enrolment_state === IFairePay.EnrolmentState.PRE_ENROLLED_CHECKED_OUT,
        balance_limit: balance_limit
    };
};
